import * as React from 'react';
import cn from 'classnames';
import { ArticleParagraph2 } from '@cian/ui-kit';
import { ILocation } from '../../../../../types/location';
import * as styles from './styles.css';

export interface IPopularRegionsDesktopProps {
  locations: ILocation[];
  selectedLocationId: number;

  onLocationSelect(location: ILocation): void;
}

export const PopularRegionsDesktop: React.FC<IPopularRegionsDesktopProps> = props => {
  const { locations, onLocationSelect, selectedLocationId } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        {locations.map(location => (
          <div
            className={cn(styles['item'], {
              [styles['item-selected']]: selectedLocationId === location.id,
            })}
            key={location.id}
            onClick={() => onLocationSelect(location)}
          >
            <ArticleParagraph2 color="current_color">{location.displayName}</ArticleParagraph2>
          </div>
        ))}
      </div>
    </div>
  );
};

PopularRegionsDesktop.displayName = 'PopularRegionsDesktop';
